import { Controller } from "@hotwired/stimulus"

// 발췌 검수는 선택 공개(opt-in)다 — 체크한 것만 공개 페이지에 실린다.
// 전부 고르는 것이 흔한 선택인데 항목마다 눌러야 하므로 버튼 하나를 둔다.
//
// 버튼은 상태를 따라간다. 다 골라 놓고 같은 자리를 다시 누르면 «선택»이 그대로
// 있는 편이 어색하다 — 누를 수 있는 것이 남아 있다는 뜻으로 읽히기 때문이다.
// 그래서 전부 골라진 동안에는 «취소»로 바꾼다. 손으로 마지막 하나를 켜거나 끈
// 경우에도 같아야 하므로 폼의 change를 듣는다(체크박스의 change는 위로 흐른다).
//
// 라벨은 서버가 넘긴다. 이 파일에 한국어를 적으면 로케일 파일과 두 벌이 된다.
export default class extends Controller {
  static targets = [ "checkbox", "toggle", "status" ]
  static values = {
    selectLabel: String,
    deselectLabel: String,
    publicLabel: String,
    privateLabel: String
  }

  connect() {
    this.refresh()
  }

  toggleAll(event) {
    event.preventDefault()

    const nextChecked = !this.allSelected
    this.selectableCheckboxes.forEach((checkbox) => {
      if (checkbox.checked === nextChecked) return

      checkbox.checked = nextChecked
      // 직접 켜고 끈 것도 사용자가 누른 것과 같은 이벤트를 흘린다 — 이 컨트롤러의
      // refresh도, 나중에 붙을 다른 코드도 한 가지 신호만 보게 한다.
      checkbox.dispatchEvent(new Event("change", { bubbles: true }))
    })

    this.refresh()
  }

  refresh() {
    this.refreshRowLabels()

    if (!this.hasToggleTarget) return

    this.toggleTarget.textContent = this.allSelected ? this.deselectLabelValue : this.selectLabelValue
  }

  // 행의 «공개 / 공개 안 함»은 서버가 찍어 두지만 체크를 따라가야 한다. 저장 전에도
  // "지금 고른 대로면 어떻게 되는지"를 읽을 수 있어야 하기 때문이다.
  refreshRowLabels() {
    this.checkboxTargets.forEach((checkbox) => {
      const row = checkbox.closest("label")
      const status = row && row.querySelector('[data-excerpt-review-target="status"]')
      if (!status) return

      status.textContent = checkbox.checked ? this.publicLabelValue : this.privateLabelValue
    })
  }

  get selectableCheckboxes() {
    return this.checkboxTargets.filter((checkbox) => !checkbox.disabled)
  }

  // 고를 것이 하나도 없으면 "다 골랐다"고 하지 않는다 — 빈 목록에서 버튼이
  // «취소»로 떠 있으면 끌 것이 있는 것처럼 보인다.
  get allSelected() {
    const boxes = this.selectableCheckboxes
    return boxes.length > 0 && boxes.every((checkbox) => checkbox.checked)
  }
}
